import type { OfferReduxBaseState } from '../types/offerReduxBaseState';

export const getSponsor = (state: OfferReduxBaseState) => {
    const sponsor = state?.widgetSettings?.sponsor ?? '';
    return sponsor.toLowerCase();
};

export const getIsSalesView = (state: OfferReduxBaseState): boolean => {
    return Boolean(state?.dealer?.enableDealerShowroomExperience && state?.widgetSettings?.userRole === 'salesperson');
};
